<template>
  <b-row>

    <b-col class="container text-right">
      <b-button
        variant="primary"
        @click="onBtnAddClicked"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>เพิ่มข้อมูล</span>
      </b-button>
    </b-col>

    <b-card class="mt-2 col-12">

      <b-col cols="12">
        <SearchFilter
          @handleSubmit="searchFilterSubmit"
        />
      </b-col>


    </b-card>

    <b-col
      cols="12"
    >
      <commonTable
        ref="tableCommon"
        :routeName="routeName" 
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BTabs, BTab, BButton, BCard, BCardHeader, BCardBody,
} from 'bootstrap-vue'
import commonTable from './components/commonTable.vue'
import SearchFilter from './components/SearchFilter.vue'


export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
  },
  props: {
    routeName: String
    },
  data() {
    return {
    }
  },
  // beforeMount(){
  //   //console.log("this.$route.name;:",this.$route.name)
  // },
  methods: {
    searchFilterSubmit(params){
        this.$refs.tableCommon.onSearchSubmit(params)
    },
    onBtnAddClicked() {
      var masterTypeId = 0;
      if(this.routeName == 'MasterPurchasePlace'){
        masterTypeId = 8;
      }
      else if(this.routeName == 'MasterPurchasePropagate'){
        masterTypeId=9;
      }
      else if(this.routeName == 'MasterPurchaseMethod'){
        masterTypeId = 10;
      }
      else if(this.routeName == 'MasterNotifyPurpose'){
        masterTypeId = 12;
      }
      window.open(this.$router.resolve({ name: 'MasterPurchaseManage', query: { masterTypeId }}).href, '_blank');
    }
  },
}
</script>

 <style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
